import { z } from 'zod'

export const STRATALYST_AGENT_RUN_RESULT_CONTRACT_VERSION = '1.0.0' as const
export const stratalystAgentRunResultResponseSchema = z.unknown()
export type StratalystAgentRunResultResponse = z.infer<typeof stratalystAgentRunResultResponseSchema>
